import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { locales } from "../../locales";

ChartJS.register(ArcElement, Tooltip, Legend);

const PopulationByNationality = ({ data, langId, isDesktop }) => {
  // calculate total percentage
  const total_percentage = Object.entries(data).reduce(
    (acc, [key, value]) => acc + value,
    0
  );
  // calculate others percentage
  const others_percentage = (100 - total_percentage).toFixed(2);

  // add others percentage to data
  const newData = { ...data, others: others_percentage };

  // create labels colors
  const colors = {
    lu: "#1b5a80",
    de: "#b6e1f3",
    it: "#86cdeb",
    fr: "#4da6cd",
    pt: "#2a80b7",
    others: "#2396B7ff",
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: 0,
    },
    tooltips: {
      enabled: true,
    },
    plugins: {
      legend: {
        labels: {
          boxWidth: 31,
          boxHeight: 23,
          color: "#000",
        },
        display: true,
        position: "bottom",
        align: "start",
      },
    },
  };
  const optionsDesktop = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: 0,
    },
    tooltips: {
      enabled: false,
    },
    plugins: {
      legend: {
        labels: {
          boxWidth: 16,
          boxHeight: 16,
          color: "#000",
        },
        text: "test",
        display: true,
        position: "bottom",
        align: "start",
      },
    },
  };

  // plugins
  // const doughnutLabelsLine = {
  //   id: "doughnutLabelsLine",
  //   afterDraw: (chart, args, options) => {
  //     const {
  //       ctx,
  //       chartArea: { width, height },
  //     } = chart;

  //     chart.data.datasets.forEach((dataset, i) => {
  //       chart.getDatasetMeta(i).data.forEach((datapoint, j) => {
  //         const { x, y } = datapoint.tooltipPosition();

  //         // draw line to label text
  //         const halfWidth = width / 2;
  //         const halfHeight = height / 2;
  //         const xLine = x >= halfWidth ? x + 50 : x - 50;
  //         const yLine = y >= halfHeight ? y + 15 : y - 15;
  //         const extraLine = x >= halfWidth ? 15 : -15;

  //         // line from datapoint to label text
  //         ctx.beginPath();
  //         ctx.moveTo(x, y);
  //         ctx.lineTo(xLine, yLine);
  //         ctx.lineTo(xLine + extraLine, yLine);
  //         ctx.strokeStyle = dataset.backgroundColor[j];
  //         ctx.stroke();

  //         // control the position of the text
  //         const textXPosition = x >= halfWidth ? "left" : "right";
  //         const plusFivePx = x >= halfWidth ? 5 : -5;
  //         ctx.font = "12px Fira Sans Condensed";
  //         ctx.textAlign = textXPosition;
  //         ctx.textBaseline = "middle";
  //         ctx.fillText(
  //           chart.data.labels[j],
  //           xLine + extraLine + plusFivePx,
  //           yLine
  //         );
  //       });
  //     });
  //   },
  // };
  const labels = Object.keys(newData).filter((label) => label in colors);
  const inputObject = labels.map((label) => newData[label]);
  const backgroundColor = labels.map((label) => colors[label]);
  const localizedLabels = labels.map(
    (label) =>
      locales[langId].nationalities[label] +
      " (" +
      newData[label].toString().replace(".", ",") +
      "%)"
  );
  const chartObject = {
    labels: localizedLabels,
    datasets: [
      {
        label: "",
        data: inputObject,
        backgroundColor: backgroundColor,
        borderWidth: 1,
      },
    ],
  };

  return (
    <Doughnut
      data={chartObject}
      options={isDesktop ? optionsDesktop : options}
      // plugins={isDesktop ? [doughnutLabelsLine] : []}
    />
  );
};

export default PopulationByNationality;
